<template>
    <router-view name="header"></router-view>
    <router-view name="nav"></router-view>
    <router-view></router-view>
</template>